<template>
  <div class="bb-contact-service" @drop.prevent @dragover.prevent>
    <div v-if="!editModeOff" class="bb-contact-service-title">
      <span v-if="!state.companyName">Add Vendor</span>
      <span>{{ state.companyName }}</span>
    </div>
    <div
      v-else
      class="bb-contact-service-header"
    >
      VENDOR
      <div class="bb-contact-service-header-buttons">
        <i class="icon-edit bb-icon bb-icon_accent" @click="onOpenEdit"/>
        <i class="icon-trash-1 bb-icon bb-icon_red" @click.stop="onClosePopup"/>
      </div>
      <transition name="bounce">
        <div class="bb-contact-service-header-popup"
             v-click-outside="onClosePopup"
             v-if="isHidePopup">
          <span class="bb-contact-service-header-popup__title">Are you sure?</span>
          <div class="bb-contact-service-header-popup-buttons-wrapper">
            <button class="bb-contact-service-header-popup-buttons-wrapper__button bb-button"
                    type="submit"
                    @click="deleteServiceProviderItem">
              Yes
            </button>
            <button class="bb-contact-service-header-popup-buttons-wrapper__button bb-button"
                    type="submit"
                    @click="isHidePopup = !isHidePopup">
              No
            </button>
          </div>
        </div>
      </transition>
    </div>
    <VuePerfectScrollbar style="height: 100%" class="bb-contact-service-body" ref="leftPanel">
      <div>
        <div
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Company name</label>
          <input
            @keyup.enter="onSave"
            v-autofocus
            v-if="!editModeOff"
            v-model.trim="state.companyName"
            class="bb-contact-service-wrap__input"
            :class="{'bb-contact-service-wrap__input_validate': state.companyName === '' && validation}"
            type="text">
          <span class="bb-contact-service-wrap__description" v-else>{{ state.companyName }}</span>
          <transition name="fade" appear>
              <span v-if="state.companyName === '' && validation" class="bb-contact-service-wrap__error">
                Can't be blank
              </span>
          </transition>
        </div>
        <div
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Status</label>
          <div v-if="!editModeOff" class="bb-contact-service-wrap__input bb-contact-service-wrap__select">
            <BBSelect
              :options="userInput.list"
              :value="status"
              @change="onChangeOption"
              label="name"
            />
          </div>
          <span class="bb-contact-service-wrap__description" v-else>{{ status.name }}</span>
        </div>
        <div
          v-if="state.address || !editModeOff"
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Full address</label>
          <textarea v-if="!editModeOff"
                    v-model.trim="state.address"
                    class="bb-contact-service-wrap__textarea"
                    type="text"/>
          <span v-else class="bb-contact-service-wrap__description">
             <a v-if="isUrl(state.address)"
                target="_blank"
                class="bb-contact-service-wrap-description__href"
                :href="state.address">{{ state.address }}
             </a>
            <span
              v-else>{{ state.address }}
            </span>
          </span>
        </div>
        <template v-if="showContacts">
          <ContactVendor
            v-for="(contact, index) in contacts"
            :key="contact.id"
            :contact="contact"
            :contactIndex="index"
            :lastContactIndex="contacts.length - 1"
            :editable="!editModeOff"
            :positionsList="positionsList"
            @addContact="addContact"
            @removeContact="removeContact"
            @addPhoneContact="addPhoneContact"
            @removePhoneContact="removePhoneContact"
            @addEmailContact="addEmailContact"
            @removeEmailContact="removeEmailContact"
          />
        </template>
        <div
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Type of provider</label>
          <SelectTagVendor v-if="!editModeOff"
                           class="bb-contact-service-wrap__input bb-contact-service-wrap__select-tag"
                           :options="vendorTags"
                           :values="state.vendorTags"
                           @change="selectedTag"
          />
          <TagsVendor v-else
                      :limitCount="limitCount"
                      :tags="state.vendorTags"
          />
        </div>
        <div
          v-if="state.services || !editModeOff"
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Services/Goods</label>
          <textarea v-if="!editModeOff"
                    v-model.trim="state.services"
                    class="bb-contact-service-wrap__textarea"/>
          <span class="bb-contact-service-wrap__description" v-else>{{ state.services }}</span>
        </div>
        <div
          v-if="state.details || !editModeOff"
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Details</label>
          <textarea v-if="!editModeOff"
                    v-model.trim="state.details"
                    class="bb-contact-service-wrap__textarea-details"/>
          <span class="bb-contact-service-wrap__description" v-else>{{ state.details }}</span>
        </div>
        <div
          v-if="currentFiles.length || !editModeOff"
          class="bb-contact-service-wrap"
          :class="{'bb-contact-service-wrap_edit': editModeOff}"
        >
          <label>Price list</label>
          <div>
            <transition-group name="list" tag="div">
              <div v-for="(item, index) in currentFiles"
                   :key="`${item.id}${item.name}${item._id}`"
                   class="bb-contact-service-wrap-list">
                <div
                  @click="openFile(item)"
                  class="bb-contact-service-wrap-list-section"
                  :class="{'bb-contact-service-wrap-list-section_edit-mode': editModeOff}"
                >
                  <i class="icon-file"/>
                  <span class="bb-contact-service-wrap-list-section__text">
                    {{ item.name || item.label }}
                  </span>
                </div>
                <div v-if="!editModeOff"
                     @click="deleteFile(index, item)"
                     class="bb-contact-service-wrap-list__button">
                  <i class="icon-cross"/>
                </div>
              </div>
            </transition-group>
            <template v-if="!editModeOff">
              <label ref="bbFiles"
                     class="bb-contact-service-wrap__file"
                     for="upload-photo"
                     @dragenter="drop = true"
                     @dragover="drop = true"
                     @dragleave="drop = false"
                     @drop="onDrop"
                     :class="{'bb-contact-service-wrap__file_highlight': drop}">
                <i class="icon-vector"/>
                Add file
              </label>
              <input
                v-if="!editModeOff"
                style="display: none;"
                type="file"
                multiple
                id="upload-photo"
                @change="setFile"
              >
            </template>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div v-if="!editModeOff" class="bb-contact-service-footer-buttons">
      <ButtonsEdit
        @edit="onSave"
        @delete="onCancel"
        left-if="true"
        no-pop-up="false"
        btn-right-text="CANCEL"
        btn-left-text="SAVE"/>
    </div>
  </div>
</template>

<script>
import BBSelect from '@/components/Main/Inputs/BBSelect'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SelectTagVendor from './SelectTagVendor'
import TagsVendor from './TagsVendor'
import ServiceProviderApi from '@/api/ServiceProvider/api'
import ServiceProviderDepartmentsApi from '@/api/ServiceProviderDepartment/api'
import UploadFileApi from '@/api/UploadFile/api'
import VendorTagsApi from '@/api/VendorTags/api'
import PositionsUsersApi from '@/api/Users/api'
import {find, map, cloneDeep, isEqual, get} from 'lodash'
import setFileData from '@/mixin/setFileData'
import {ACTIVE_SERVICE_PROVIDER, PROSPECT_SERVICE_PROVIDER, NOT_ACTIVE_SERVICE_PROVIDER} from '@/constants/serviseProvider'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import { VENDORS_TAB_ID } from '@/constants/crm';
import ContactVendor from "./ContactVendor.vue";
export default {
  name: 'ContactServiceProvider',
  components: {ButtonsEdit, BBSelect, VuePerfectScrollbar, SelectTagVendor, TagsVendor, ContactVendor},
  mixins: [setFileData],
  data () {
    return {
      isHide: false,
      drop: false,

      state: {
        companyName: '',
        address: '',
        vendorTags: [],
        details: '',
        services: '',
        id: 0,
      },
      contacts: [{
        id: 'new 1',
        contactPerson: '',
        department: '',
        position: '',
        email: [{id: '0', value: ''}],
        phone: [{
          number: '',
          telegram: false,
          whatsapp: false,
          viber: false
        }],
      }],

      contactsInit: [],

      copyState: {},

      limitCount: 0,
      loaderRun: false,
      visibleFile: false,
      editModeOff: false,
      status: ACTIVE_SERVICE_PROVIDER,
      userInput: {
        list: [ACTIVE_SERVICE_PROVIDER, PROSPECT_SERVICE_PROVIDER, NOT_ACTIVE_SERVICE_PROVIDER]
      },
      validation: false,
      currentFiles: [],
      copyCurrentFiles: [],
      isRoute: true,
      isHidePopup: false,
      crypt: true,
      files: {},
      positionsList: [],
    }
  },
  computed: {
    showContacts() {
      const id = this.$route.params.id;

      if (this.editModeOff && id !== 'new' && this.contacts.length === 1) {
        return !this.contacts[0].id.includes('new');
      }

      return true
    },
    vendorTags: {
      get: function () {
        return this.$store.getters.vendorTags
      },
      set: function (data) {
        this.$store.dispatch('setVendorTags', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    currentDomain() {
      const { id } = this.$store.getters.currentDomain || {};
      return id || 4;
    },
  },
  methods: {
    addContact() {
      const lastIndex = this.contacts.length - 1;
      const { contactPerson } = this.contacts[lastIndex];

      if (!contactPerson) return;

      this.contacts.push({
        id: `new ${this.contacts.length + 1}`,
        contactPerson: '',
        department: '',
        position: '',
        email: [{id: `${Date.now()}`, value: ''}],
        phone:[{
          number: '',
          telegram: false,
          whatsapp: false,
          viber: false
        }],
      })
    },
    removeContact (index) {
      this.contacts.splice(index, 1)
    },
    addPhoneContact(contactIndex) {
      const contact = this.contacts[contactIndex];
      contact.phone.push(
        {
          number: '',
          telegram: false,
          whatsapp: false,
          viber: false
        }
      )

    },
    removePhoneContact(index, contactIndex) {
      const contact = this.contacts[contactIndex];
      contact.phone.splice(index, 1)
    },
    addEmailContact(contactIndex) {
      const contact = this.contacts[contactIndex];
      contact.email.push(
        {
          value: '',
          id: `${Date.now()}`
        }
      )

    },
    removeEmailContact(index, contactIndex) {
      const contact = this.contacts[contactIndex];
      contact.email.splice(index, 1)
    },
    onClosePopup () {
      this.isHidePopup = !this.isHidePopup
    },
    isUrl (str) {
      try {
        return new URL(str)
      } catch (e) {
        return false
      }
    },
    scrollTop () {
      if (this.$refs.leftPanel) {
        this.$refs.leftPanel.$el.scrollTop = 0
        this.$refs.leftPanel.$el.scrollLeft = 0
      }
    },
    selectedTag (tags) {
      this.state.vendorTags = tags
    },
    getTagsVendor () {
      VendorTagsApi.getVendorTags()
        .then((resp) => {
          this.vendorTags = resp.data
        })
        .catch((err) => {
          console.error(err)
        })
    },
    onChangeOption (e) {
      this.status = e
    },
    onOpenEdit () {
      this.copyState = cloneDeep(this.state)
      this.editModeOff = false
      this.copyCurrentFiles = cloneDeep(this.currentFiles)
    },
    async onSave () {
      this.validation = !this.state.companyName

      if (this.state.companyName) {
        const serviceProvider = {...this.state}
        serviceProvider.vendorTags = serviceProvider.vendorTags.map(item => item.id)
        serviceProvider.status = this.status.id
        const arrayFiles = await this.getFullInfo(this.currentFiles)
        serviceProvider.uploadFile = arrayFiles.map(f => f.id)

        serviceProvider.contactPerson = '';
        serviceProvider.email = '';
        serviceProvider.phone = '';

        this.$emit('loader', true);

        if (!this.state.id) {
          await this.createServiceProvider(serviceProvider)
        } else {
          const { rating, ...restServiceProvider } = serviceProvider;
          await this.changeServiceProvider(restServiceProvider);
        }

        this.$emit('loader', false);

        this.editModeOff = true
        this.validation = false
      }
    },
    async getFullInfo (data) {
      this.$emit('loader', true)
      const promises = data.map(async item => {
        item = await this.uploadFile(item)
        return item
      })
      const result = await Promise.all(promises)
      this.$emit('loader', false)
      return result
    },
    onCancel () {
      if (!this.state.id) {
        this.$router.push({name: 'ContactsList'})
      } else {
        this.currentFiles = cloneDeep(this.copyCurrentFiles);
        this.state = cloneDeep(this.copyState);
        this.contacts = cloneDeep(this.contactsInit);
        this.status = find(this.userInput.list, {id: this.copyState.status});
      }
      this.editModeOff = true
    },
    async getServiceProviderItem (id) {
      const route = this.$route.params;
      this.editModeOff = !route.editMode;

      try {
        const { data } = await ServiceProviderApi.getServiceProviderItem(id);
        const {contactPerson, email, phone, department, ...restData } = data;

        if (contactPerson) {
          this.contacts = [
            {
              id: 'new -1',
              department: '',
              phone: Array.isArray(phone)
                ? phone
                : [{
                  number: phone,
                  telegram: false,
                  whatsapp: false,
                  viber: false
                }]
              ,
              email: [{id: '-1', value: email}],
              contactPerson,
              position: ''
            },
            ...department,
          ];

          this.contactsInit = department;

        } else {
          this.contacts = !department.length
            ? [{
                id: 'new 0',
                department: '',
                phone: [{
                    number: '',
                    telegram: false,
                    whatsapp: false,
                    viber: false
                  }],
                email: [{id: '-1', value: ''}],
                contactPerson: '',
                position: ''
              }]
            : department.map(item => {
                const { email = [] } = item || {};
                return {
                  ...item,
                  email: email.map((emailValue, index) => ({
                    id: `${emailValue}-${index}`,
                    value: emailValue
              }))
            }
          });
          this.contactsInit = cloneDeep(this.contacts);
        }

        const state = {
          ...restData,
          contactPerson,
          email,
          phone
        }

        this.copyState = cloneDeep(state);
        this.state = state;

        this.copyCurrentFiles = cloneDeep(data.uploadFile);
        this.currentFiles = data.uploadFile;
        this.status = find(this.userInput.list, {id: data.status});
      } catch (e) {

      }
    },
    async deleteServiceProviderItem () {
      const id = this.$route.params.id;
      const department = this.contactsInit.map(contact => contact.id);

      try {
        this.$emit('loader', true);

        await Promise.all([
          ServiceProviderApi.deleteServiceProvider(id),
          ServiceProviderDepartmentsApi.removeDepartments(department, this.currentDomain)
        ])

        await this.$router.push({name: 'ContactsList', params: { tabId: VENDORS_TAB_ID }});
      } catch (e) {
        console.error(e);
      } finally {
        this.$emit('loader', false);
      }
    },
    async createServiceProvider (serviceProvider) {
       try {
           const { data } = await ServiceProviderApi.createServiceProvider(serviceProvider);
           const { id: serviceProviderId, ...resetData } = data;

           const departmentData = this.contacts
             .filter(contact => contact.contactPerson.trim() || contact.department.trim())
             .map(contact => {
             const { id, email, ...restData } = contact;
             return {
               ...restData,
               serviceProvider: serviceProviderId,
               email: email.map(item => item.value)
             }
           })

         const {
             data: dataDepartments
           } = await ServiceProviderDepartmentsApi.createDepartments(departmentData, this.currentDomain);

         this.copyState = cloneDeep(resetData);
         this.state = resetData;

         const dataDepartmentsUpdated = dataDepartments.map(item => {
           const { email } = item;
           return {
             ...item,
             email: email.map((emailValue, index) => ({
               id: `${emailValue}-${index}`,
               value: emailValue
             }))
           }
         })

         this.contacts = dataDepartmentsUpdated;
         this.contactsInit = cloneDeep(dataDepartmentsUpdated);

         await this.$router.replace({name: 'ContactServiceProvider', params: {id: serviceProviderId, contactType: 3}})
       } catch (e) {
           console.error(e);
       }
    },
    async changeServiceProvider (serviceProvider) {

        const deletedDepartments = this.contactsInit
            .filter((initContact) => !this.contacts.find((contact) => contact.id === initContact.id))
            .map((initContact) => initContact.id);

      const newDepartments = this.contacts
        .filter((contact) => contact.id.includes('new')
          && (contact.contactPerson.trim() || contact.department.trim()))
        .map((contact) => {
          const { id, email, ...restData } = contact;
          return {
            ...restData,
            serviceProvider: serviceProvider.id,
            email: email.map(item => item.value)
          };
        });

        const updatedDepartments = this.contacts.filter((contact) => {

            if (contact.id.includes('new')) return false;

            const searchedInitContact = this.contactsInit.find((contactInit) => contactInit.id === contact.id);

            if (searchedInitContact) {
                const {
                    contactPerson,
                    department,
                    position,
                    email,
                    phone
                } = searchedInitContact;

                const {
                  phone: phoneCurrentContact,
                  email: emailCurrentContact
                } = contact;


              const isNotEqualPrimitive = contactPerson.trim() !== contact.contactPerson.trim()
                || department.trim() !== contact.department.trim()
                || position !== contact.position;

              if (isNotEqualPrimitive) return true

                if (
                  phone.length !== phoneCurrentContact.length
                  || email.length !== emailCurrentContact.length
                ) return true

              for (let i = 0; i < phone.length; i++) {
                const initPhone = phone[i];
                const currentPhone = phoneCurrentContact[i];

                if (!isEqual(initPhone, currentPhone)) {
                  return true
                }
              }

              for (let i = 0; i < email.length; i++) {
                const initEmail = email[i];
                const currentEmail = emailCurrentContact[i];

                if (initEmail.value.trim() !== currentEmail.value.trim()) {
                  return true
                }
              }

            }
            return false;
        })
          .map(contact => ({
              ...contact,
              email: contact.email.map(item => item.value)
          }));

        try {
            const { data } = await ServiceProviderApi.changeServiceProvider(serviceProvider);

            const [departmentsCreated, departmentsUpdated] = await Promise.all([
                ServiceProviderDepartmentsApi.createDepartments(newDepartments, this.currentDomain),
                ServiceProviderDepartmentsApi.updateDepartments(updatedDepartments, this.currentDomain),
                ServiceProviderDepartmentsApi.removeDepartments(deletedDepartments, this.currentDomain),
            ]);

            const {department, ...restData } = data;

            this.state = restData;
            this.copyState = cloneDeep(restData);

          const notUpdatedDepartments = this.contacts.filter(contact => {
            return !contact.id.includes('new')
              && !updatedDepartments.find(item => item.id === contact.id)
          })

            const updateDataDepartment = (dataDepartments) => {
              return dataDepartments.map(item => {
                const { email = [] } = item || {};
                return {
                  ...item,
                  email: email.map((emailValue, index) => ({
                    id: `${emailValue}-${index}`,
                    value: emailValue
                  }))
                }
              })
            }


          this.contacts = [
              ...notUpdatedDepartments,
              ...updateDataDepartment(departmentsCreated.data),
              ...updateDataDepartment(departmentsUpdated.data)
            ];
            this.contactsInit = cloneDeep(this.contacts);

            this.currentFiles = data.uploadFile;
            this.copyCurrentFiles = cloneDeep(data.uploadFile);

        } catch (e) {
            console.error(e);
        }
    },
    setFile (e) {
      if (!e.target.files.length) {
        return
      }
      const files = map(e.target.files, file => file)
      files.map(el => (el._id = Date.now()))
      this.currentFiles = [...this.currentFiles, ...files]
      e.target.value = ''
    },
    async uploadFile (fileData) {
      if (fileData.id) return fileData
      const file = this.setFileData(fileData)
      try {
        const res = await UploadFileApi.createFile(file, this.crypt)
        return res.data
      } catch (err) {
        console.error(err)
      }
    },
    deleteFile (index, item) {
      if (!this.editModeOff) {
        this.currentFiles.splice(index, 1)
      } else {
        UploadFileApi.deleteFile(item.id, this.crypt)
          .then(res => {
            this.currentFiles.splice(index, 1)
          })
          .catch((e) => {
            console.error(e)
          })
      }
    },
    openFile (file) {
      if (!file.id) {
        const objectURL = window.URL.createObjectURL(file)
        file.type.includes('image') ? window.open(objectURL, file.name) : saveAs(file, file.name)
      } else {
        this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
      }
    },
    getFile (file) {
      this.$emit('loader', true)
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.$emit('loader', false)
        })
        .catch(err => {
          this.$emit('loader', false)
          console.error(err)
        })
    },
    listener (e) {
      if (e.keyCode === 27 && !this.editModeOff) {
        this.onCancel()
      }
    },
    onDrop (e) {
      this.drop = false
      const newFile = get(e, 'dataTransfer.files', '')
      const files = map(newFile, file => file)
      files.map(el => (el._id = Date.now()))
      this.currentFiles = [...this.currentFiles, ...files]
    },
    async getPositionsList() {
      try {
        const { data } = await PositionsUsersApi.getUsersPositionsList();
        this.positionsList = data.positions;
      } catch (e) {
        console.error(e);
      }
    },
  },
  watch: {
    editModeOff (newVal) {
      this.scrollTop()
    },
    activeCompany () {
      this.getTagsVendor()
    }
  },
  mounted () {
    this.$refs.leftPanel.$el.addEventListener('keydown', this.listener)
  },
  async beforeMount () {
    const id = this.$route.params.id
    this.$emit('loader', true);

    if (id === 'new') {
        await this.getPositionsList()
    } else {
        await Promise.all([
          this.getPositionsList(),
          this.getServiceProviderItem(id)
        ])
    }

    this.$emit('loader', false);

    if (this.vendorTags.length === 0 || this.vendorTags[0].company !== this.activeCompany) {
      this.getTagsVendor()
    }
  },
  beforeDestroy () {
    this.$refs.leftPanel.$el.removeEventListener('keydown', this.listener)
  }
}

</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-contact-service {
  @include global-font;
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  width: 446px;
  margin: -10px -20px;
  z-index: 1;
  background: $color-white;
  border-radius: 5px;
  font-size: 13px;

  &-header {
    display: flex;
    justify-content: space-between;
    padding: 18px 20px;
    color: $color-accent;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    border-bottom: 2px solid $color-alabaster;
    margin-bottom: 40px;

    &-buttons {
      display: flex;
      width: 50px;
      justify-content: space-between;
    }

    &-popup {
      position: absolute;
      top: 20px;
      right: 45px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $color-white;
      box-shadow: 0 0 15px rgba($color-black, 0.05);
      border-radius: 5px;
      z-index: 2;
      padding: 14px;
      min-width: 117px;

      &_top {
        bottom: 0;
        top: auto;
      }

      &_no-edit {
        right: 50px;
      }

      &__title {
        font-size: 14px;
        line-height: 17px;
        color: $color-black;
        font-weight: normal;
      }

      &-buttons-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &__button {
          margin-top: 13px;
          width: 39px;
          height: 26px;
        }
      }
    }
  }

  &-title {
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    margin: 18px 0 15px;
  }

  &-wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 0 26px;
    margin-bottom: 20px;
    color: $color-accent;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;

    &_edit {
      display: flex;
      justify-content: space-between;
      padding: 0 0 13px;
      margin: 0 20px 13px;
      border-bottom: 1px solid $color-wild-sand;
      color: $color-accent;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;

      &:last-child {
        border-bottom: none;
      }
    }

    &-description {

      &__href {
        text-decoration: none;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        color: $color-black;
        display: block;

        &:hover {
          color: $color-accent-hover;
          border-color: $color-accent-hover;
        }
      }
    }

    &-list {
      display: flex;

      &-section {
        display: flex;
        align-items: center;
        padding-left: 13px;
        width: 178px;
        height: 30px;
        border: 1px solid $color-mercury;
        box-sizing: border-box;
        border-radius: 5px;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 12px;
        margin-right: 8px;
        cursor: pointer;

        &__text {
          padding: 0 8px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          color: $color-black;

          &:hover {
            color: $color-accent-hover;
            transition: 0.3s;
          }
        }

        &__icon:hover {
          color: $color-accent-hover;
          transition: 0.3s;
        }

        &:hover {
          border-color: $color-borders;
          transition: 0.3s;
        }

        &_edit-mode {
          display: flex;
          flex-direction: row-reverse;
          padding: 0;
          margin: 0;
          border: none;
        }
      }

      &__button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid $color-mercury;
        box-sizing: border-box;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
          border-color: $color-borders;
          transition: 0.3s;
        }
      }
    }

    &__file {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 216px;
      height: 30px;
      border: 1px dashed $color-denim;
      box-sizing: border-box;
      border-radius: 5px;
      color: $color-denim;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      cursor: pointer;
      transition: 0.3s;
      margin-bottom: 75px;

      &:hover {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }

      &_highlight {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }
    }

    &__description {
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      color: $color-black;
      width: 216px;
      text-align: right;
      white-space: pre-wrap;
      word-break: break-all;
    }

    &__error {
      position: absolute;
      left: 330px;
      top: 8px;
      color: $color-red-orange;
      font-size: 11px;
      line-height: 13px;
      font-weight: 300;
      transition: 0.3s;
    }

    &__input {
      width: 216px;
      height: 30px;
      border: 1px solid $color-mercury;
      border-radius: 5px;
      box-sizing: border-box;
      font-weight: 300;
      font-size: 13px;
      line-height: 16px;
      padding: 7px 10px;
      @include global-font;

      &_validate {
        border: 1px solid $color-red-orange;
        width: 216px;
        height: 30px;
        border-radius: 5px;
        box-sizing: border-box;
        font-weight: 300;
        font-size: 13px;
        line-height: 16px;
        padding: 7px 10px;
      }
    }

    &__textarea {
      width: 216px;
      border: 1px solid $color-mercury;
      border-radius: 5px;
      box-sizing: border-box;
      font-weight: 300;
      font-size: 13px;
      line-height: 16px;
      padding: 7px 10px;
      height: 70px;
      resize: none;
      @include global-font;
    }

    &__textarea-details {
      width: 216px;
      border: 1px solid $color-mercury;
      border-radius: 5px;
      box-sizing: border-box;
      font-weight: 300;
      font-size: 13px;
      line-height: 16px;
      padding: 7px 10px;
      height: 120px;
      resize: none;
      @include global-font;
    }

    &__select {
      color: $color-black;
      padding: 0;
      border: none;
    }

    &__select-tag {
      color: $color-black;
      padding: 0;
      border: none;
      height: auto;
    }
  }

  &-footer-buttons {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    background: $color-white;
    width: 446px;
    padding-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/ContactServiceProvider.vue